import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { ProfileState } from 'store/modules/profile_store/types';

// A faixa do convite só existe na home e nunca divide o topo com o banner de amostra.
// Quem só contrata Seguro Garantia não usa a plataforma e não recebe o convite.
export function useAmbassadorInviteBanner(): boolean {
  const { pathname } = useLocation();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const isOnlyConlicitaseg = useOnlyConlicitaseg();

  if (pathname !== '/painel' || !profile.isSigned || isOnlyConlicitaseg) return false;
  if (profile.in_sample || panel?.registration_type_validation === 1) return false;

  return Boolean(profile.ambassador?.invited && !profile.ambassador?.member);
}

export default useAmbassadorInviteBanner;
